import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/series',
    name: 'series',
    component: () => import(/* webpackChunkName: "series" */ '../views/SeriesView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/ContactView.vue')
  },
  // 动态路由，处理所有其他路径
  {
    path: '/:pathMatch(.*)*',
    name: 'dynamic',
    component: () => import(/* webpackChunkName: "dynamic" */ '../views/DynamicPageView.vue')
  },
  {
    // path: '/macrophotography',
    // name: 'macrophotography',
    // component: () => import(/* webpackChunkName: "macrophotography" */ '../views/macrophotography.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

// 获取滚动容器的辅助函数
const getScrollContainer = () => {
  // 等待 DOM 完全加载
  const appElement = document.getElementById('app');
  return appElement || window;
}

// 滚动到顶部的函数
const scrollToTop = () => {
  const container = getScrollContainer();
  
  // 检查容器是否有 scrollTo 方法
  if (container && container.scrollTo) {
    container.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' // 使用平滑滚动，提升用户体验
    });
  } else if (container) {
    // 降级方案
    container.scrollTop = 0;
  }
  
  // 同时确保 body 和 html 也滚动到顶部（兼容性处理）
  if (document.body) document.body.scrollTop = 0;
  if (document.documentElement) document.documentElement.scrollTop = 0;
}

// 全局导航守卫，确保路由切换时滚动到顶部
router.beforeEach((to, from, next) => {
  // 立即滚动到顶部（不使用平滑滚动，确保立即生效）
  const container = getScrollContainer();
  if (container) {
    container.scrollTop = 0;
  }
  // 备用方案
  window.scrollTo(0, 0);
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  
  next();
});

router.afterEach(() => {
  // 延迟一点时间再次滚动到顶部，确保页面内容加载完成
  setTimeout(() => {
    scrollToTop();
  }, 100);
  
  // 对于动态加载的内容，可能需要更长的延迟
  setTimeout(() => {
    scrollToTop();
  }, 300);
});

export default router